import { __decorate } from "tslib";
import { injectable } from "inversify";
import { MutableStore } from "../../store";
let LocalizationOptionsStore = class LocalizationOptionsStore extends MutableStore {
    getLocaleByCode(localeCode) {
        return this.value.wellKnownLocales.find(x => x.localeCode == localeCode);
    }
    getLocalesByCountry(countryCode) {
        return this.value.wellKnownLocales.filter(x => x.countryCode == countryCode);
    }
    getLocalesByLanguage(langCode) {
        return this.value.wellKnownLocales.filter(x => x.langCode == langCode);
    }
    getSupportedLocales() {
        return this.value.wellKnownLocales;
    }
    isSupportedLocale(locale) {
        return this.getSupportedLocales().some(x => x.equals(locale));
    }
    getBestSupportedLocale(locale) {
        return (this.value.wellKnownLocales.find(x => x.equals(locale)) ??
            this.value.wellKnownLocales.find(x => x.countryCode == locale.countryCode) ??
            this.value.wellKnownLocales.find(x => x.langCode == locale.langCode));
    }
    getDefaultLocale() {
        return this.value.defaultLocale;
    }
};
LocalizationOptionsStore = __decorate([
    injectable()
], LocalizationOptionsStore);
export { LocalizationOptionsStore };
//# sourceMappingURL=LocalizationOptions.js.map